import { compose } from '../../../util'
import { injectIntl } from 'react-intl'
import { ToggleToNewDashboard } from '../../../components/dashboard-toggle'
import { createNgReactBridgeDirective } from '../../react-bridge'

export const reactToggleToNewDashboard = createNgReactBridgeDirective(
  'reactToggleToNewDashboard',
  [],
  compose(injectIntl)(ToggleToNewDashboard),
  ['onClick']
)
